/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/components/business-profiles-list/business-profiles-list.component.scss */
mat-list-item:hover .bp-call-to-action,
.mat-mdc-list-item:hover .bp-call-to-action {
  visibility: visible;
}
.bp-call-to-action {
  display: flex !important;
  visibility: hidden;
}
mat-list-item *[aria-expanded=true],
.mat-mdc-list-item *[aria-expanded=true] {
  visibility: visible;
}
/*# sourceMappingURL=business-profiles-list.component.css.map */
